import { router } from '@inertiajs/react'
import { Shield } from 'lucide-react'
import { buildExcludedParam } from '@/frontend/lib/auditLogs'
import CommandCenterLayout from '@/frontend/layouts/CommandCenterLayout'
import AuditLogFilters from '@/frontend/pages/CommandCenter/AuditLogs/AuditLogFilters'
import AuditLogTable from '@/frontend/pages/CommandCenter/AuditLogs/AuditLogTable'

interface FilterOption {
  id: string
  name: string
}

interface Props {
  audit_logs: Array<{
    id: string
    audit_action: string
    description: string
    details: Record<string, unknown>
    ip_address: string | null
    created_at: string
    actor_name: string | null
    worker_name: string | null
    digital_worker_id: string | null
    organization_id: string
    organization_name: string
    worker_path: string | null
  }>
  pagination: { page: number; total_pages: number; total: number }
  filters: {
    organizations: FilterOption[]
    digital_workers: FilterOption[]
    users: FilterOption[]
  }
  search: string
  organization_id: string
  excluded_actions: string[]
  digital_worker_id: string
  user_id: string
  date_from: string
  date_to: string
}

function AuditLogsIndex(props: Props) {
  const submit = (page = 1, overrides: Record<string, unknown> = {}) => {
    const { excluded_actions: overriddenExcluded, ...restOverrides } = overrides
    const excluded = (overriddenExcluded ?? props.excluded_actions) as string[]

    router.get('/cc/audit_logs', {
      page,
      organization_id: props.organization_id,
      excluded_actions: buildExcludedParam(excluded),
      digital_worker_id: props.digital_worker_id,
      user_id: props.user_id,
      date_from: props.date_from,
      date_to: props.date_to,
      search: props.search,
      ...restOverrides,
    }, { preserveState: true })
  }

  return (
    <div>
      <div className="flex items-center gap-3 mb-6">
        <Shield className="h-6 w-6 text-foreground" />
        <h2 className="text-2xl font-bold text-foreground">Auditoria</h2>
        <span className="text-sm text-muted-foreground">({props.pagination.total})</span>
      </div>

      <AuditLogFilters
        filters={props.filters}
        search={props.search}
        organization_id={props.organization_id}
        excluded_actions={props.excluded_actions}
        digital_worker_id={props.digital_worker_id}
        user_id={props.user_id}
        date_from={props.date_from}
        date_to={props.date_to}
        onSubmit={submit}
      />

      <AuditLogTable
        audit_logs={props.audit_logs}
        pagination={props.pagination}
        onPageChange={(page) => submit(page)}
      />
    </div>
  )
}

AuditLogsIndex.layout = (page: React.ReactElement) => <CommandCenterLayout>{page}</CommandCenterLayout>

export default AuditLogsIndex
